import React, { useState, useEffect } from 'react';
import styles from './EditNextOfKinModal.module.css';

// 1. Swap initialData prop to memberData to sync with your main profile state
const EditNextOfKinModal = ({ isOpen, onClose, memberData, onSave }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    relationship: '',
    phoneNumber: '',
    address: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 2. Hydrate form state metrics when modal opens or memberData changes
  useEffect(() => {
    if (isOpen && memberData) {
      setFormData({
        fullName: memberData.next_of_kin_name || '',
        relationship: memberData.next_of_kin_relationship || '',
        phoneNumber: memberData.next_of_kin_phone || '',
        address: memberData.next_of_kin_address || ''
      });
    }
  }, [isOpen, memberData]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      const payload = {
        next_of_kin_name: formData.fullName,
        next_of_kin_relationship: formData.relationship,
        next_of_kin_phone: formData.phoneNumber,
        next_of_kin_address: formData.address,
      };

      const saved = await onSave(payload);
      if (saved !== false) {
        onClose();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Edit Next of Kin Information</h2>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formColumn}>
            
            <div className={styles.formGroup}>
              <label htmlFor="fullName">Full Name <span className={styles.required}>*</span></label>
              <input 
                type="text" 
                id="fullName"
                name="fullName" 
                value={formData.fullName} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="relationship">Relationship <span className={styles.required}>*</span></label>
              <input 
                type="text" 
                id="relationship"
                name="relationship" 
                placeholder="e.g. Spouse, Brother, Parent"
                value={formData.relationship} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="phoneNumber">Phone Number <span className={styles.required}>*</span></label>
              <input 
                type="tel" 
                id="phoneNumber"
                name="phoneNumber" 
                value={formData.phoneNumber} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="address">Address <span className={styles.required}>*</span></label>
              <textarea 
                id="address"
                name="address" 
                rows="3"
                value={formData.address} 
                onChange={handleChange} 
                required 
              />
            </div>

          </div>

          <div className={styles.formActions}>
            <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={isSubmitting}>Cancel</button>
            <button type="submit" className={styles.saveBtn} disabled={isSubmitting}>
              {isSubmitting ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditNextOfKinModal;